module.exports = __webpack_public_path__ + "img/111.5.ef138303.png";